"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactions_1 = require("../../selectors/reactions");
var reactions_2 = require("../../stores/reactions");
var _kernel_container_1 = __importDefault(require("../../../container"));
var global_1 = require("../../selectors/global");
function runPendingReactionsTasks() {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, request, timer, state, isConnected, nextPendingReactionTask, dislikes, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/runPendingReactionsTasks");
                    request = _kernel_container_1.default.get("REQUEST");
                    timer = _kernel_container_1.default.get("TIMER");
                    state = getState();
                    isConnected = (0, global_1.selectIsConnected)(state);
                    if (!isConnected) {
                        logger.debug("In offline mode, skipping tasks run");
                        return [2];
                    }
                    if ((0, reactions_1.selectReactionSendInProgress)(state)) {
                        logger.debug("Reaction task already in progress, skipping tasks run");
                        return [2];
                    }
                    nextPendingReactionTask = (0, reactions_1.selectNextPendingReactionTask)(state);
                    if (!nextPendingReactionTask) return [3, 7];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    logger.info("Running reaction task", { task: nextPendingReactionTask });
                    dispatch((0, reactions_2.markDislikeTaskAsInProgress)(nextPendingReactionTask));
                    dislikes = void 0;
                    if (!(nextPendingReactionTask.type === "dislike")) return [3, 3];
                    return [4, request.dislikeStreamMediafile(nextPendingReactionTask.id, nextPendingReactionTask.streamId)];
                case 2:
                    dislikes = _a.sent();
                    return [3, 5];
                case 3: return [4, request.restoreDislikedStreamMediafile(nextPendingReactionTask.id, nextPendingReactionTask.streamId)];
                case 4:
                    dislikes = _a.sent();
                    _a.label = 5;
                case 5:
                    dispatch(reactions_2.setDislikedFiles.apply(void 0, __spreadArray([], __read(dislikes.map(function (dislike) { return ({
                        id: Number(dislike.mediafileId),
                        streamId: Number(dislike.streamId),
                    }); })), false)));
                    dispatch((0, reactions_2.recalculateDislikes)());
                    logger.debug("Got dislikes", { dislikes: dislikes });
                    logger.debug("Marking task as done", { task: nextPendingReactionTask });
                    dispatch((0, reactions_2.markTaskAsDone)(nextPendingReactionTask));
                    timer.setTimeout(function () {
                        dispatch(runPendingReactionsTasks());
                    }, 100);
                    return [3, 7];
                case 6:
                    e_1 = _a.sent();
                    logger.error("Got error while trying to run reaction task", {
                        task: nextPendingReactionTask,
                        error: e_1.toString(),
                    });
                    dispatch((0, reactions_2.removeDislikeTaskFromInProgress)(nextPendingReactionTask));
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); };
    action.type = runPendingReactionsTasks.type;
    return action;
}
exports.default = runPendingReactionsTasks;
runPendingReactionsTasks.type = "runPendingReactionsTasks";
//# sourceMappingURL=runReactionsTasks.js.map